import { Header } from '../../../ui/header/header';
import { Sidebar } from '../../../ui/sidebar/sidebar';
import { Button } from '../../../ui/button/button';
import { Table } from '../../../ui/table/table';
import { useDispatch } from 'react-redux';
import { Checkbox } from '../../../ui/input/checkbox';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { push } from 'connected-react-router';
import { PathParams, RoutingPath } from '../../../../routes/routing-path';
import { useAppSelector } from '../../../../app/hooks';
import { LogDecorator } from '@tenryu/log-decorator';
import './print-order-preparation.scss';
import { dialogActions } from '../../../dialog/slice/dialog-slice';
import { AngleIcon } from '../../../ui/angle-icon/angle-icon';
import * as lodash from 'lodash';
import { ColorIcon } from '../../../ui/color-icon/color-icon';
import { orderPreparationActions } from '../../../../slices/order-preparation-slice';
import { useParams } from 'react-router-dom';
import { xmlActions } from '../../../../xml/slice/xml-slice';
import { DomContentTooltip } from '../../../ui/tooltip/dom-content-tooltip';
import { commonActions } from '../../../../slices/common-slice';
import { localStorageActions } from '../../../../slices/local-storage-slice';
import { isEqual } from 'lodash';
import warningIcon from '../../../../assets/img/icon/warning_icon.svg'
import { PRINT_ITEM_STATUS, PRINT_ITEM_STATUS_LIST, PrintDataStructure, PrintItemDataEntity } from '../../../../models/sift/json/print-model';
import { PrintSideBar } from './component/print-sidebar';
import { printActions } from '../../../../slices/sift/print-slice';
import { usePrintOrder } from '../hooks/use-print-order';
import { PrintImageList } from './component/image-list.print';
import { PrintImagesDataEntity } from '../../../../api/sift/front/api-print-image';
import { PrintPreparationImagesList } from './print-order-preparation-item-images-list';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { usePrintLock } from '../hooks/use-print-lock';
import { usePrintStatus } from '../hooks/use-print-status';
import { ApiBaseFront } from '../../../../api/front/api-base-front';
import { MetaPrintShopOrderGetResponse } from '../../../../api/sift/front/api-print-meta-shop-order';
import { LaboOrderCompChecker } from '../../../../utilities/labo-order-comp-checker';

export const SelectCondition = (props: { selected: boolean }) => {
  const { selected } = props;
  return <AngleIcon direction={selected ? 'bottom' : 'top'} />;
};

const OrderStatus = (props: { status: string, kijshopCd: string, shopOrderId: string, orderId: string }) => {
  const { status: _status, kijshopCd, shopOrderId, orderId } = props;
  const { xml, isLaboOrderRetry } = useAppSelector((state) => ({
    xml: state.xml[shopOrderId],
    isLaboOrderRetry: state.orderPreparation.isLaboOrderRetry,
  }), isEqual)
  const isError = useMemo<boolean>(() => {
    const orderInfo = xml?.orderInfo?.infoData?.find((infoData) => {
      return infoData.xml.metaModel.id === orderId;
    });
    if (!orderInfo) {
      return false;
    };
    if (orderInfo.xml.metaModel.layoutFinish === '3') {
      return true;
    }
    return false;
  }, [xml]);
  const [status, setStatus] = useState(_status);
  const [warningIconTooltip, setWarningIconTooltip] = useState(false);
  const warningIconRef = useRef(null);

  useEffect(() => {
    setStatus(_status);
  }, [_status]);
  return (
    <div className={`labeled_icon_hr${isLaboOrderRetry ? ' error' : ''}`} ref={warningIconRef} onMouseEnter={() => setWarningIconTooltip(true)} onMouseLeave={() => setWarningIconTooltip(false)} >
      {(isError || isLaboOrderRetry) && <img src={warningIcon} alt="" />}
      {warningIconTooltip && (isError || isLaboOrderRetry) && <DomContentTooltip
        onClick={(e) => {
          e.stopPropagation();
        }}
        content={
          isLaboOrderRetry ?
            (<div className={"order_preparation__warning-icon-tooltip"}>
              <div>発注処理が正常に完了しませんでした</div>
              <div>「再発注」ボタンをクリックしてください</div>
            </div>) :
            (<div className={"order_preparation__warning-icon-tooltip"}>
            <div>保存処理でエラーが発生しました</div>
            <div>レイアウト画面に戻ってエラー箇所を確認してください</div>
          </div>)
        }
        relativeEle={warningIconRef.current}
        autoPos={{ h: 'center', v: 'bottom' }}
      /> }
      {isLaboOrderRetry || <ColorIcon color={status} />}
      {status}
    </div>
  );
};
const NeedAgreement = (props: { agreement: string, kijshopCd: string, shopOrderId: string, orderId: string }) => {
  const { agreement: _agreement, kijshopCd, shopOrderId, orderId } = props;
  const dispatch = useDispatch();
  const [agreement, setAgreement] = useState(_agreement);
  const handlerClickCheck = useCallback((v) => {
    dispatch(xmlActions.order({ kijshopCd, shopOrderId }).changeIsNeedAgreement(orderId, v !== 'true'));
    setAgreement((v !== 'true') ? 'true' : 'false');
  }, [kijshopCd, shopOrderId, orderId]);
  useEffect(() => {
    if (agreement !== _agreement) {
      setAgreement(_agreement);
    }
  }, [_agreement]);
  return agreement ? (
    <div>
      <Checkbox
        value={agreement}
        label="有"
        checked={agreement === 'true'}
        onClick={(e) => handlerClickCheck(e.currentTarget.value)}
      />
    </div>
  ) : (<div>-</div>);
};


// 注文概要画面（元注文作成準備画面）
export const PrintOrderPreparation = () => {
  // - Effect -
  // -- ログまとめ --
  const lockActions = usePrintLock();
  useEffect(() => {
    LogDecorator.group('<green>注文作成準備</green>');
    return () => LogDecorator.groupEnd();
  }, []);
  const { kijshopCd, shopOrderId } = useParams<PathParams>();
  const {
    currentData,
    currentMeta,
    master,
    storage,
    selectedOrderIdArr,
  } = useAppSelector((state) => ({
    currentData: state.print.printShopOrderData[shopOrderId],
    currentMeta: state.print.printShopOrderMeta[shopOrderId],
    selectedOrderIdArr: state.orderPreparation.selectedOrderIdArr,
    master: state.common.data.masterShop,
    storage: state.storage,
  }), lodash.isEqual);

  // - Hooks -
  const dispatch = useDispatch();

  const {
    getData,
    getImages,
    getThumbImages,
    imageUpload,
    editableImages,
    memo,
    uploadProgress,
    uploadProgressView,
    loadingActions,
    labOrder,
    onLoadMeta: _onLoadMeta,
    isLabOrderRetry,
  } = usePrintOrder();

  const {
    changeStatus,
    changeLastUpdateDate,
    centerStatusName,
    statusName,
    isOrdered,
  } = usePrintStatus();

  // - State -
  // -- テーブルprops select --
  const [selected, setSelected] = useState<number[]>([]);
  const [loadImageList, setLoadImageList] = useState(false);
  const [loadMeta, setLoadMeta] = useState(false);
  const [loadStructure, setLoadStructure] = useState(false);
  const [uploadImageList, setUploadImageList] = useState<PrintImagesDataEntity[]>([]);
  const [thumbImages, setThumbImages] = useState<PrintImagesDataEntity[]>([]);
  // ラボ発注済みかの管理フラグ
  // ラボ発注ボタンの活性状態管理
  const isLaboOrderDisabled = useMemo(() => {
    // お客様氏名がない時
    if (!currentMeta?.lastName) return true;
    // ラボ発注後 再発注可じゃないとき
    const items = currentData?.meta.getItemList() ?? [];
    if (
      (statusName === 'ラボ発注中' && !isLabOrderRetry)
      || centerStatusName
    ) {
      return true;
    }
    // 商品がない　またはラボ発注可ではない商品があるとき
    return !items.length || !items.every((v) => v.status === 10);
  }, [
    currentData,
    currentMeta,
    statusName,
    centerStatusName,
    isLabOrderRetry,
  ]);

  const initLoadStatus = useMemo(() => {
    return [
      loadImageList,
      loadMeta,
      loadStructure,
    ].some((v) => !v)
      ? '情報を取得中です...'
      : '';
  }, [
    loadImageList,
    loadMeta,
    loadStructure,
  ]);

  // - Callback -
  // -- select更新 --
  const handlerChangeSelected = useCallback((v) => {
    const id = currentData?.meta?.getItemList()[v]?.id;
    if (id) {
      dispatch(orderPreparationActions.setSelectedOrderId({ id, index: v + 1 + v }));
    }
    setSelected((prev) => {
      const arr = [...prev];
      const index = arr.findIndex((i) => i === v);
      if (index === -1) {
        arr.push(v);
      } else {
        arr.splice(index, 1);
      }
      arr.sort((a, b) => a - b);
      return arr;
    });
  }, [selected, currentData]);

  const handlerOrderDelete = useCallback((id: string) => {
    dispatch(dialogActions.pushMessage({
      title: '削除',
      message: [
        '選択した注文情報を削除します。よろしいですか？',
      ],
      buttons: [
        { label: 'キャンセル', callback: () => dispatch(dialogActions.pop()) },
        { label: 'OK', callback: () => {
          dispatch(dialogActions.pop());
          dispatch(printActions.shopOrder({ kijshopCd, shopOrderId }).item().delete(id, {
            success: async(res) => {
              getData();
              if (res) {
                if (!res.getItemList().length) {
                  await changeStatus('create');
                } else {
                  if (res.getItemList().every((res) => res.status === PRINT_ITEM_STATUS.enableOrder)) {
                    await changeStatus('enableOrder');
                  } else {
                    changeLastUpdateDate();
                  }
                }

              }
            }
          }));
        } }
      ]
    }));
  }, [
    dispatch,
    kijshopCd, shopOrderId,
    getData,
    changeStatus,
    changeLastUpdateDate,
  ]);

  // -- 注文作成 --
  const handlerClickCreateOrder = useCallback(() => {
    if (!loadImageList) {
      return;
    }
    if (uploadImageList.length) {
      dispatch(push(RoutingPath.cnv.printOrderAddOrderSelect({ kijshopCd, shopOrderId })));
    } else {
      dispatch(push(RoutingPath.cnv.printOrderAddImageUpload({ kijshopCd, shopOrderId })));
    }
  }, [
    dispatch,
    shopOrderId, kijshopCd,
    loadImageList,
    uploadImageList,
  ]);

  const handlerClickToneCorrection = useCallback(() => {
    dispatch(push(RoutingPath.cnv.printToneCorrection({ kijshopCd, shopOrderId })))
  }, [
    kijshopCd, shopOrderId,
    dispatch,
  ]);

  const insertPage = useMemo(() => {
    const list = [...(currentData?.meta.getItemList() ?? [])];
    return list.map((v, i) => ({
      index: i + 1 + (i),
      element: (
        <PrintPreparationImagesList
          id={v.id}
          onDelete={handlerOrderDelete}
          images={editableImages}
          thumbImages={thumbImages}
          memo={{
            ...memo,
            value: memo.value[v.id] ?? '',
          }}
          ordered={isOrdered || !!currentMeta?.orderDate}
          productData={v.productData}
        />
      )
    }))
  }, [
    currentData,
    currentMeta,
    handlerOrderDelete,
    editableImages,
    thumbImages,
    memo,
    isOrdered,
  ]);

  const onClickToneCollectionMemo = useCallback((data?: PrintDataStructure) => {
    const metaData = data ?? currentData?.meta;
    const filter = metaData?.toneCorrection?.filter((v) => v.value) ?? [];
    const openItems = metaData?.getItemList().map((v, i) => ({item: v, index: i })).filter((v) => {
      return v.item.images.some((img) => img.count && filter.find((filterImg) => filterImg.id === img.id ))
        || v.item.images.find((v) => v.trimmingStatus === 3 && v.count);
    }) ?? [];
    openItems.forEach((v) => {
      const id = v.item.id;
      if (!selectedOrderIdArr.includes(id)) {
        dispatch(orderPreparationActions.setSelectedOrderId({ id, index: v.index + 1 + v.index }));
      }
    });
    setSelected(openItems.map((v) => v.index));
  }, [
    currentData,
    selectedOrderIdArr,
    dispatch,
  ]);

  const getImageList = useCallback(() => {
    getImages().then((images) => {
      setUploadImageList(images?.fileList || []);
    }).finally(() => {
      setLoadImageList(true);
    });
    getThumbImages().then((images) => {
      setThumbImages(images?.fileList ?? []);
    })
  }, [getImages, setThumbImages]);
  const addImage = useCallback((files: File[]) => {
    imageUpload(files, (ei) => {
      getImageList();
    })
  }, [
    imageUpload,
    getImageList,
  ]);
  // -- 一覧データ取得 --
  useEffect(() => {
    getData().then((structure) => {
      setLoadStructure(true);
      getImageList();
      onClickToneCollectionMemo(structure.meta);
    }).catch((e) => {
      setLoadStructure(true);
      setLoadImageList(true);
    });
  }, []);

  useEffect(() => {
    return () => {
      dispatch(orderPreparationActions.resetSelectedOrderId());
    };
  }, []);

  const tableData = (currentData?.meta?.getItemList() ?? []).map((orderInfoData, i) => {
    const buzaiData = (param: PrintItemDataEntity) => {
      const borderType = param.productData?.meta?.borderType ?? '';
      const borderList = param.productData?.itemElements.find((v) => v.progFlg === 'edgeDtemp');
      const border = borderList?.list.find((v) => v.dataId === borderType)?.dataName ?? ''
      const paperType = param.productData?.meta?.paperType ?? '';
      const paperList = param.productData?.itemElements.find((v) => v.progFlg === 'paper');
      const paper = paperList?.list.find((v) => v.dataId === paperType)?.dataName ?? ''
      const laminateType = param.productData?.meta?.laminateType ?? '';
      const laminateList = param.productData?.itemElements.find((v) => v.progFlg === 'laminate');
      const laminate = laminateList?.list.find((v) => v.dataId === laminateType)?.dataName ?? ''
      const tapeList = param.productData?.additional?.info1 ?? [];
      const tapeType = param.productData?.meta?.additionalInfo ?? '';
      const matList = param.productData?.additional?.info2 ?? [];
      const matType = param.productData?.meta?.additionalInfo2 ?? '';
      const tape = tapeList.find((v) => v.additionalInfoId === tapeType)?.additionalInfoName ?? '';
      const mat = matList.find((v) => v.additionalInfo2Id === matType)?.additionalInfo2Name ?? '';
      const result: string[] = [];
      if (paper) result.push(`ペーパー種: ${paper}`);
      if (laminate) result.push(`ラミネート種: ${laminate}`);
      if (border) result.push(`フチ: ${border}`);
      if (tape) result.push(`テープ色: ${tape}`)
      if (mat) result.push(`マット: ${mat}`)
      return result.join(' ');
    }
    const status = (() => {
      if (!centerStatusName) {
        if (statusName === 'ラボ発注中') {
          if (
            currentMeta?.orderCompleteDate
            && LaboOrderCompChecker.checkTimeoutForPrint({ orderCompleteDate: currentMeta.orderCompleteDate })
          ) {
            return '送信エラー';
          }

          return 'ラボ発注中';
        } else {
          return (PRINT_ITEM_STATUS_LIST.find((v) => v.value === orderInfoData.status)?.label ?? '');
        }
      }
      return centerStatusName;
    })();
    return ([
      <SelectCondition
        selected={Boolean(selected.find((index) => index === i) !== undefined)}
      />,
      <OrderStatus
        status={status}
        kijshopCd={kijshopCd}
        shopOrderId={shopOrderId}
        orderId=""
      />,
      orderInfoData.productData?.ProductDetailItemData?.itemName ?? '',
      buzaiData(orderInfoData),
      'プリントまとめて注文',
    ]);
  }).filter((v) => v.length);

  const onLoadMeta = useCallback((v?: MetaPrintShopOrderGetResponse) => {
    _onLoadMeta(v);
    setLoadMeta(true);
  }, [
    _onLoadMeta,
  ]);


  useEffect(() => {
    if (selected.length) {
      setSelected([]);
    }
  }, [tableData.length]);
  useEffect(() => {
    if (storage.kijshopCd !== kijshopCd || storage.kijshopCd === '') {
      dispatch(localStorageActions.getLocalData(kijshopCd));
    }
    if (!master) {
      dispatch(commonActions.getData(kijshopCd));
    }
    return () => {
      dispatch(orderPreparationActions.resetOrderData());
      dispatch(orderPreparationActions.resetCompImages());
    };
  }, []);

  return (
    <div className="order_preparation page_base">
      <Header />
      <div className="order_preparation__body">
        <PrintSideBar
          memo={memo.value}
          resetItemMemo={memo.resetItemMemo}
          onGetMeta={onLoadMeta}
          ordered={!!currentMeta?.orderDate || isOrdered}
        />
        <div className="order_preparation__body__contents">
          <div className="order_preparation__body__contents__menu">
            <Button
              label="注文作成"
              onClick={handlerClickCreateOrder}
              disabled={!currentData?.meta || !loadImageList || isOrdered || !!currentMeta?.orderDate}
            />
            <Button
              label={isLabOrderRetry ? '再発注' : 'ラボ発注'}
              onClick={labOrder}
              disabled={isLaboOrderDisabled}
            />
            <Button
              label="色補正指示"
              disabled={!currentData?.meta?.getUseImageIdList().length || isOrdered || !!currentMeta?.orderDate}
              onClick={() => handlerClickToneCorrection()}
            />
            {/*NOTE:2025.05.27不要に...@kurokawa*/}
            {/*<div className="tone_collection_memo_btn">*/}
            {/*  <Button*/}
            {/*    label="色調・トリミング要望を追記"*/}
            {/*    disabled={*/}
            {/*      !currentData?.meta?.toneCorrection.filter((v) => v.value).length*/}
            {/*      && !currentData?.meta?.getItemList()?.find((v) => v.images.find((v2) => v2.trimmingStatus === 3 && v2.count))*/}
            {/*    }*/}
            {/*    onClick={() => onClickToneCollectionMemo()}*/}
            {/*  />*/}
            {/*  <span>※各商材ごとにご記入ください</span>*/}
            {/*</div>*/}
          </div>
          <div className="order_preparation__body__contents__table">
            <Table
              head={[
                '',
                'ステータス',
                'ラボ商品名',
                '部材・加工',
                '注文方法',
              ]}
              body={tableData}
              selected={selected}
              handlerSelect={handlerChangeSelected}
              minimumNumOfRows={10}
              excludedIndex={7}
              insertPage={insertPage}
              cursorPointer
              theme="print"
            />
          </div>
          <PrintImageList
            imgData={uploadImageList}
            kijshopCd={kijshopCd}
            shopOrderId={shopOrderId}
            progress={uploadProgress}
            progressView={uploadProgressView}
            imageUpload={addImage}
            ordered={!!currentMeta?.orderDate || isOrdered}
          />
        </div>
      </div>
      <loadingActions.LoadingPopup forceMessage={initLoadStatus} />
    </div>
  );
};
